



























































import Vue from 'vue';
import { isBefore, isEqual } from 'date-fns';

// Services and types
import AnalyticService from '~/services/AnalyticService';
import UserInfoService from '~/services/UserInfoService';
import { HIGHERED_CV_TEMPLATE } from '~/services/ResourceService';
import VFairService, { GetVFairParams, VFair } from '~/services/VFairService';
import { RestXReactiveData } from '~/utils/types';
import { SchoolVerification, SchoolVerificationState } from '~/services/SchoolService';

// Project components
import MainLayout from '~/components/layouts/mainlayout/MainLayout.vue';
import VFairList from './components/VFairList.vue';
import LinkCard from './components/LinkCard.vue';
import Paper from '~/components/builders/Paper.vue';
import Footer from '../components/Footer.vue';
import Header from '~/components/layouts/Header.vue';
import SchoolVerificationAlert from '~/components/miscellaneous/SchoolVerificationAlert/SchoolVerificationAlert.vue';

// Assets
import CV from '~/assets/img/vcf/CV.jpg';
import MasterClass from '~/assets/img/vcf/Masterclass.jpg';
import ElevatorPitch from '~/assets/img/vcf/ElevatorPitch.jpg';

export default Vue.extend({
    name: 'FindVFairs',
    props: {
        suppressLogging: Boolean,
    },
    components: {
        MainLayout,
        VFairList,
        LinkCard,
        Paper,
        Footer,
        Header,
        SchoolVerificationAlert,
    },
    data() {
        return {
            cv: CV,
            elevatorPitch: ElevatorPitch,
            masterClass: MasterClass,
            cvTemplateLink: HIGHERED_CV_TEMPLATE,
            organizations: [],
            // companiesLoading: false,
            showHackGif: false,
            hackClicked: false,
            hackTrue: !!localStorage.getItem('vfair_hack'),

            vfairs: [] as VFair[],

            loadingInitial: false,
            loading: false,

            selectedSchoolId: '' as SchoolVerification['schoolId'] | '',
        };
    },
    computed: {
        hasVFairs(): boolean {
            return this.$interfaces.vfairModule.getHasVFairs();
        },
        isAuthenticated(): boolean {
            return (this as any).$interfaces.logInModule.isLoggedIn();
        },
        schoolVerifications(): RestXReactiveData<SchoolVerification[]> {
            return (this as any).$interfaces.university.connection.get({ reactive: true });
        },
        hasAnySchoolVerifications(): boolean {
            return this.schoolVerifications.data.length > 0;
        },
        hasVerifiedSchoolVerifications(): boolean {
            return (
                this.schoolVerifications.data.filter(
                    school => school.state === SchoolVerificationState.verified
                ).length > 0
            );
        },
    },
    methods: {
        refreshVFairs(): Promise<void> {
            this.loading = true;

            const vfairService = new VFairService();
            return vfairService
                .getVFairsByParams(this.buildVFairParams())
                .then(data => {
                    this.vfairs = data.filter(this.vfairFilter);
                })
                .catch(error => {
                    console.error(error);
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        buildVFairParams(): Partial<GetVFairParams> {
            const isHigheredAdmin = UserInfoService.isHigheredAdmin();
            let endAfter = new Date();

            return {
                open: true,
                schoolId:
                    this.selectedSchoolId !== ''
                        ? [this.selectedSchoolId]
                        : UserInfoService.getSchoolAdminIds(),
                private: isHigheredAdmin,
                network: true,
                endAfter: endAfter,
            };
        },
        vfairFilter(vfair: VFair): boolean {
            const isHigheredAdmin = UserInfoService.isHigheredAdmin();
            if (!isHigheredAdmin && !vfair.studentVisibility) {
                return false;
            }
            let check = vfair.start;
            if (vfair.end) {
                check = vfair.end;
            }
            let now = new Date();

            return vfair.active && (isBefore(now, check) || isEqual(now, check));
        },
        goToProfileEducation() {
            this.$router.push({
                name: 'profile',
                query: { scrollTo: 'educations' },
            });
        },
    },
    mounted() {
        AnalyticService.impressionEvent(AnalyticService.IMPRESSION_ACTIONS.VFAIRLIST_VIEW_ACTION);

        this.loadingInitial = true;
        this.refreshVFairs().finally(() => {
            this.loadingInitial = false;
        });
    },
    watch: {
        isAuthenticated(newValue: boolean, oldValue: boolean) {
            if (!oldValue && newValue) {
                this.refreshVFairs();
            }
        },
        schoolVerifications(newValue: SchoolVerification[], oldValue: SchoolVerification[]) {
            if (newValue.length > 0 && oldValue.length === 0) {
                this.refreshVFairs();
            }
        },
        selectedSchoolId(
            newValue: SchoolVerification['schoolId'] | '',
            oldValue: SchoolVerification['schoolId'] | ''
        ) {
            if (newValue !== oldValue) {
                this.refreshVFairs();
            }
        },
    },
});
